import { produce } from 'immer';

import { UpdateInternalMarketerPageStatus } from '../../../actions/marketer/internal/updateInternalMarketerPageStatus';
import { MarketerState } from '../../../typings/marketers';

export function updateInternalMarketerPageStatus(
    state: MarketerState,
    action: UpdateInternalMarketerPageStatus
): MarketerState {
    return produce(state, draft => {
        draft.pageStatus = action.pageStatus;
    });
}
